const SDK_VERSION = '7.93.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
